import React, { useState, useEffect, useMemo } from "react";
import { connect } from 'react-redux';
import { Actions as EMPLOYEEACTIONS } from '../../store/actions/employeeActions';
import _, { set } from 'lodash';
import { validateFloat } from "../common/validation/Validators";

const LeaveCarryoverRow = ({
    employee,
    employeeLeaveBalances,
    setEmployeeCarryover,
    currentCarryover,
    carryoverValues,
}) => {

    const totalLeave = employeeLeaveBalances.vlTotalBal
    const carryoverAll = carryoverValues?.carryoverAll
    const maxCarryover = parseFloat(carryoverValues?.maxCarryover) || 0
    const maxPayable = parseFloat(carryoverValues?.maxPayable) || 0

    useEffect(() => {
        if (!!carryoverAll) {
            setEmployeeCarryover(employee.id, Math.max(totalLeave,0), 0)
            return
        }

        const min = Math.max(Math.min(maxCarryover, totalLeave),0)
        const payable = Math.max(Math.min(maxPayable, totalLeave - min),0)
        setEmployeeCarryover(employee.id, parseFloat(min.toFixed(2)), parseFloat(payable.toFixed(2)))
    }, [totalLeave, carryoverAll, maxCarryover, maxPayable])

    const carryover = currentCarryover?.carryover
    const payable = currentCarryover?.toPay
    const isValid = currentCarryover?.isValid

    const difference = useMemo(() => (
        totalLeave - (carryover == '-' ? 0 : carryover) - payable
    ), [totalLeave, carryover, payable])

    return (
        <tr>
            <td>{employee?.employeeName} {employee?.employeeSurname}</td>
            <td>{parseFloat(totalLeave).toFixed(2)}</td>
            <td>
                <input
                    style={{ width: "50px", textAlign: "center" }}
                    value={carryover}
                    onChange={(e) => {
                        setEmployeeCarryover(employee.id, validateFloat(e.target.value), payable)
                    }}
                />
            </td>
            <td>
                <input
                    style={{ width: "50px", textAlign: "center" }}
                    value={payable}
                    onChange={(e) => {
                        setEmployeeCarryover(employee.id, carryover, validateFloat(e.target.value))
                    }}
                />
            </td>
            <td style={!isValid ? { color: "red" } : {}}>
                {difference.toFixed(2)}
            </td>
        </tr>
    )
}


const mapStateToProps = (state, ownProps) => {

    const {
        leaveBalancesByType,
        proRataLeave,
    } = state.leave

    const {
        employee,
        viewType
    } = ownProps

    const employeeOriginalLeaveBalances = {}

    const employeeLeaveBalances = {}
    const otherLeaveTypes = []

    const leaveTypeIDs = leaveBalancesByType && Object.keys(leaveBalancesByType)

    if (leaveTypeIDs) {
        leaveTypeIDs.map(leaveTypeID => {
            const leaveTypeBalance = leaveBalancesByType[leaveTypeID].find(item => item.agreementId == employee?.id)
            console.log('leaveTypeBalance', leaveTypeBalance, employee?.id)

            if (viewType?.value == 'consumed') {

                if (leaveTypeID == 6020) {

                    employeeLeaveBalances.vlCf = leaveTypeBalance?.carryover?.toFixed(2)
                    employeeLeaveBalances.vlE = leaveTypeBalance?.entitledThisYear?.toFixed(2)
                    employeeLeaveBalances.vlConsumed = leaveTypeBalance?.consumed?.toFixed(2)
                    employeeLeaveBalances.vlTotalBal = leaveTypeBalance?.balanceThisYear?.toFixed(2)
                    employeeLeaveBalances.vlPaid = leaveTypeBalance?.paidLeaveHours?.toFixed(2)
                    employeeLeaveBalances.vlToil = leaveTypeBalance?.toil?.toFixed(2)
                    employeeLeaveBalances.vlAdj = leaveTypeBalance?.manualAdjustment?.toFixed(2)

                    employeeLeaveBalances.vlE2D = leaveTypeBalance?.entitledToDate?.toFixed(2)
                    employeeLeaveBalances.vl2D = leaveTypeBalance?.balanceToDate?.toFixed(2)

                } else if (leaveTypeID == 6022) {

                    employeeLeaveBalances.sick = leaveTypeBalance && (leaveTypeBalance.consumed || 0).toFixed(2)
                    employeeLeaveBalances.sickHP = leaveTypeBalance && ((leaveTypeBalance.halfPayRegular + leaveTypeBalance.halfPayCasual) || 0).toFixed(2)
                    employeeLeaveBalances.sickUnpaid = leaveTypeBalance && (leaveTypeBalance.unpaid || 0).toFixed(2)

                } else {

                    employeeLeaveBalances[leaveTypeID] = leaveTypeBalance && leaveTypeBalance.consumed
                    otherLeaveTypes.push(leaveTypeID);

                }

                employeeOriginalLeaveBalances[leaveTypeID] = leaveTypeBalance;

            } else {

                if (leaveTypeID == 6020) {

                    employeeLeaveBalances.vlCf = leaveTypeBalance && Math.max(leaveTypeBalance.carryover - leaveTypeBalance.consumed, 0).toFixed(2)
                    employeeLeaveBalances.vlTY = leaveTypeBalance && (leaveTypeBalance.balanceThisYear - employeeLeaveBalances.vlCf).toFixed(2)
                    employeeLeaveBalances.vlTotalBal = leaveTypeBalance?.balanceThisYear?.toFixed?.(2) || 0

                    employeeLeaveBalances.vlE2D = leaveTypeBalance && (leaveTypeBalance.balanceToDate - employeeLeaveBalances.vlCf).toFixed(2)
                    employeeLeaveBalances.vl2D = leaveTypeBalance && leaveTypeBalance.balanceToDate?.toFixed?.(2) || 0

                } else if (leaveTypeID == 6022) {

                    employeeLeaveBalances.sick = leaveTypeBalance && (leaveTypeBalance.balanceThisYear || 0).toFixed(2)
                    employeeLeaveBalances.sickHP = leaveTypeBalance && (leaveTypeBalance.halfPayBalance || 0).toFixed(2)

                } else {

                    employeeLeaveBalances[leaveTypeID] = leaveTypeBalance && leaveTypeBalance.balanceThisYear
                    otherLeaveTypes.push(leaveTypeID);

                }

                employeeOriginalLeaveBalances[leaveTypeID] = leaveTypeBalance;

            }
        })
    }

    const {
        carryover
    } = state.employees

    return {
        employeeLeaveBalances,
        employeeOriginalLeaveBalances,
        otherLeaveTypes,
        proRataLeave,
        defaultCarryover: 50,
        defaultPaid: 10,
        currentCarryover: carryover?.[employee?.id],
        carryoverValues: state?.leave?.leaveCarryoverMax,
    }
}

const mapDispatchToProps = dispatch => ({
    setEmployeeCarryover: (agreementId, carryover, toPay) => dispatch(EMPLOYEEACTIONS.validateCarryover(agreementId, carryover, toPay)),
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(LeaveCarryoverRow) 